import React, { useState } from "react";

export default function Filters({ innerText, onClick }) {
  return (
    <button className="filter" onClick={onClick} name={innerText}>
      {innerText}
    </button>
  );
}
